import { TState } from 'redux/store'

export const textInputModalSelector = (state: TState) => state.common.textInputModal
